import { render, staticRenderFns } from "./debt-follow-records.vue?vue&type=template&id=45ad4fdc"
import script from "./debt-follow-records.vue?vue&type=script&lang=ts"
export * from "./debt-follow-records.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports